import { Reducer } from "redux";

import { ReferralNoteUserListActionDispatchTypes } from "../constants/User";
import { ReferralNoteUserListResponse } from "../models/Api/User";
import { ReferralNoteUserListDispatchTypes } from "../models/DispatchTypes/User";

const initialState: ReferralNoteUserListResponse = {
  loading: false,
  response: [],
};

const ReferralNoteUserListReducer: Reducer<ReferralNoteUserListResponse, ReferralNoteUserListDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
      case ReferralNoteUserListActionDispatchTypes.REFERRAL_NOTE_USER_LIST_INVOKE: {
        return {
          ...state,
          loading: true,
        };
      }
      case ReferralNoteUserListActionDispatchTypes.REFERRAL_NOTE_USER_LIST_SUCCESS: {
        return {
          ...state,
          response: action.response,
          loading: false,
        };
      }
      case ReferralNoteUserListActionDispatchTypes.REFERRAL_NOTE_USER_LIST_RESET: {
        return initialState;
      }
      case ReferralNoteUserListActionDispatchTypes.REFERRAL_NOTE_USER_LIST_FORBIDDEN: {
        return {
          response: initialState.response,
          loading: false,
        };
      }
  }
  return state;
};

export default ReferralNoteUserListReducer;
